// @ts-nocheck
import React, { Component } from 'react';
import { computed, makeObservable } from "../../stores/mobx-shim";
import { inject, observer } from "../../stores/mobx-compat";
import { withRouter } from '../../router-compat';

import PageHeader from '../ui/PageHeader';
import Card, { CardHead } from '../ui/Card';
import Button from '../ui/Button';
import Alert from '../ui/Alert';
import CodeBlock from '../ui/CodeBlock';
import { MailIcon, ClipboardIcon } from '../ui/icons';
import ShareModal from './ShareModal';
import { API_URL } from '../../configs';

class Setup extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  state = { modalOpen: false, sendToSelf: false };

  get script() {
    const { clientId } = this.props.store.auth.user;
    return `<script>
  setTimeout(function() {
    (function (d, script) {
      script = d.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '${API_URL}/api/mov/clientId/${clientId}';
      script.setAttribute('client-id', '${clientId}')
      d.getElementsByTagName('head')[0].appendChild(script);
    }(document));
  }, 1500);
</script>`;
  }

  shareMessageHandler = (sendToSelf = false) => {
    this.setState({ sendToSelf, modalOpen: true });
  }

  render() {
    return (
      <>
        <PageHeader
          eyebrow="Setup"
          title={<>Install the <em>snippet</em>.</>}
          sub="Add the Movology snippet to your website to start tracking forms."
          actions={(
            <Button
              icon={MailIcon}
              onClick={() => this.shareMessageHandler(false)}
            >
              Send to dev team
            </Button>
          )}
        />

        <Alert tone="info" title="Need a hand?">
          You may want technical help for this step.{' '}
          <button
            type="button"
            onClick={() => this.shareMessageHandler(false)}
            className="text-mov-accent-ink underline cursor-pointer font-medium"
            style={{ background: 'transparent', border: 0, padding: 0 }}
          >
            Share the instructions with your dev team
          </button>{' '}— we&apos;ll email it on your behalf.
        </Alert>

        <Card padded className="mt-5">
          <CardHead title="Step 1 — Install the snippet" />
          <p className="m-0 text-[13px] text-mov-ink-soft">
            Put this snippet at the bottom of your website&apos;s body element. You can also install it via{' '}
            <a
              href="https://support.google.com/tagmanager/answer/6107167?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="text-mov-accent-ink underline"
            >
              Google Tag Manager
            </a>. Install the snippet before adding any forms.
          </p>

          <div className="mt-4">
            <CodeBlock code={this.script} language="html" />
          </div>

          <div className="flex gap-2 mt-3 flex-wrap">
            <Button icon={ClipboardIcon} onClick={() => {
              navigator.clipboard.writeText(this.script);
              this.props.store.success('Script copied to clipboard!');
            }}>
              Copy snippet
            </Button>
            <Button icon={MailIcon} onClick={() => this.shareMessageHandler(true)}>
              Email this to me
            </Button>
            <Button icon={MailIcon} onClick={() => this.shareMessageHandler(false)}>
              Email this to my dev
            </Button>
          </div>
        </Card>

        <Card padded className="mt-5">
          <CardHead title="Step 2 — Add your first form" />
          <p className="m-0 text-[13px] text-mov-ink-soft">
            Go to the <button
              type="button"
              onClick={() => this.props.history.push('/forms')}
              className="text-mov-accent-ink underline cursor-pointer font-medium"
              style={{ background: 'transparent', border: 0, padding: 0 }}
            >
              Forms tab
            </button> and add a form URL.
          </p>
        </Card>

        <Card padded className="mt-5">
          <CardHead title="Step 3 — Start tracking" />
          <p className="m-0 text-[13px] text-mov-ink-soft">
            Once your snippet is installed and forms are added, we&apos;ll start tracking lead behavior automatically.
          </p>
        </Card>

        <ShareModal
          open={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          sendToSelf={this.state.sendToSelf}
        />
      </>
    );
  }
}

export default withRouter(inject('store')(observer(Setup)));
